<div>BffShopView</div>